import * as React from "react";
import { inject, observer } from "mobx-react";
import { UitkExperimentaModuleMap } from "uitk-react-experimental-module-map";
import { QueryRoute } from "bernie-core";
import { withLocalization } from "bernie-l10n";
import { Experiment, isVariantEnabled } from "src/components/utility/experiment";
import { MapsProps, MapsInjectedProps } from "./typings";
import { useFullscreenOpen } from "./hooks";
import { ModuleMap, MapContext } from "./ModuleMap";

/**
 * Wrapper Map Component. Here we inject the stores and is rendered the call to action button
 * and is rendered the Main Map Component.
 * @param {MapsProps} props
 */
const MapsComponent: React.FC<MapsProps> = (props: MapsProps & MapsInjectedProps) => {
  const shouldOpenMapInHSR =
    !!props.context && isVariantEnabled(props.context, Experiment.Flex_HTG_Blossom_Map_To_HSR);

  const { toggleShowFullscreenMap, sendUserToHSR } = useFullscreenOpen(props);

  return (
    <div
      className="Maps uitk-cell all-cell-1-1 uitk-cell all-y-padding-three"
      id={props.flexComponent.id}
      data-fm={props.flexComponent.fmId}
      data-fm-title-id={props.flexComponent.fmTitleId}
    >
      <UitkExperimentaModuleMap.CallToAction
        disabled={!props.hotels.allHotelsOnMap.length}
        staticMapAlt={props.l10n.formatText(
          "maps.hotel.multipleHotels.a11yLabel",
          props.context!.searchContext.location.name
        )}
        staticMapImgUrl={props.staticMap.signedUrl}
        callToActionText={props.l10n.formatText("maps.callToActionButtonSeeWhatsAround")}
        onClick={shouldOpenMapInHSR ? sendUserToHSR : toggleShowFullscreenMap}
      />
      <MapContext.Provider
        value={{
          toggleShowFullscreenMap,
          sendUserToHSR,
          shouldOpenMapInHSR
        }}
      >
        <QueryRoute query={{ pwaDialogMap: `open-${props.flexComponent.id}` }}>
          <ModuleMap {...props} />
        </QueryRoute>
      </MapContext.Provider>
    </div>
  );
};

export const Maps = withLocalization<MapsProps, React.FC<MapsProps>>(
  inject("analytics", "routeStore", "hotels", "staticMap", "poi")(observer(MapsComponent))
);

Maps.displayName = "Maps";

export default Maps;
